window.config = {
  ENDPOINT: process.env.REACT_APP_ENDPOINT || window.config.ENDPOINT
};
